import axios from 'axios';
import { BASE_URL } from '../../../model/base-url';
export const LOGIN_URL = `http://localhost:5000/api/Auth/Login`;
export const REGISTER_URL = 'api/auth/register';
export const REQUEST_PASSWORD_URL = 'api/auth/forgot-password';
export const ME_URL = `${process.env.REACT_APP_API_URL}/auth/me`;

export function login(email, password) {
  return axios.post(`${BASE_URL}/api/auth/login`, {
    userName: email,
    password,
  });
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(`${BASE_URL}/api/Auth/GetUserInfo`);
}
